import React, {useEffect, useRef, useState} from 'react';
import {Box, Link, Grid, Card, CardContent, Button, IconButton, Typography} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import PaymentForm from '../../components/PaymentForm';
import { useUserContext } from '../../hooks/auth/UserProvider';
import { checkUserEnabled } from '../../helpers/authorizedUser';
import { ILastBuyTransaction } from '../../models/buy/Buy';
import { lastBuyTransactionsRequest } from '../../hooks/actions/buy';
import LastBuyTransactionsTable from '../../components/Buy/LastBuyTransactions';
import { useFidelityLevel } from '../../hooks/auth/FidelityLevel';
import { GREEN_MAIN } from '../../theme/colors';

const BuyTokens = () => {
    const navigate = useNavigate();
    const {t} = useTranslation();
    const [loading, setLoading] = React.useState(true);
    const [lastBuyTransactions, setLastBuyTransactions] = React.useState<ILastBuyTransaction[] | null>(null)
    const {checkIsAuth} = useUserContext();
    const [isPrivateUser, setIsPrivateUser] = useState<boolean>(false);
    // utente autorizzato
    const [isEnabled, setIsEnabled] = React.useState(false)
    const {user, auth, isForbidden} = useUserContext();
    const {fidelityLevel, fetchFidelityLevel} = useFidelityLevel();
    const [title, setTitle] = useState<string>("");
    useEffect(()=>{
        if (!auth.isLoading) {
            if (!auth.isAuthenticated) {
                navigate('/');
            } else {
                if(user){
                    if(!checkUserEnabled(user)){
                        navigate('/');
                    }
                    if(isForbidden){
                        navigate('/');
                    }
                    // PRIVATE USER
                    if(user.userType === "Private"){
                        setIsPrivateUser(true);
                    }else{
                        setIsPrivateUser(false)
                    }

                    // fidelity
                    fetchFidelityLevel().finally();
                }
                setIsEnabled(true);
                setLoading(false);
                handleLastBuyTransactions().finally();
            }
        }
        checkIsAuth().finally();
    },[auth.isAuthenticated, auth.isLoading, navigate, user])
    // fine utente autorizzato

    const handleLastBuyTransactions = async (): Promise<void> => {
        await checkIsAuth();
        try {
            const resp = await lastBuyTransactionsRequest();
            setLastBuyTransactions(resp);
        } catch (e) {
            console.error(e);
        }
    };

    return(
        <>
            <Box sx={{
                width:'100%', 
                display:'flex', 
                flexDirection:'column',
                color: GREEN_MAIN,
                fontFamily:'poppins'
            }}>
                {
                    auth.isAuthenticated && isEnabled && !isForbidden &&
                    <>
                        {/* Main title */}
                        <Typography
                            variant="h3"
                            component="h1"
                            gutterBottom
                            sx={{
                                mb: 10,
                                mt:0,
                                fontWeight: "bold",
                            }}
                        >
                            {t(title)}
                        </Typography>

                        <PaymentForm setTitle={setTitle}/>
                        
                        {/* {lastBuyTransactions && <>
                            <Box sx={{marginTop:'50px'}} />
                            <LastBuyTransactionsTable transactions={lastBuyTransactions} />
                        </>
                        } */}
                    </>
                }
            </Box>
        </>
    )
}

export default BuyTokens;